import React from 'react';
import IntroductionWrapper from '../layout/IntroductionWrapper';
import CallToActionWrapper from '../layout/CallToActionWrapper';

const Feature = ({title, description}) => {
  if (!title) return null;
  if (!description) return <li>{title}</li>;
  return (
    <li>
      <strong>{title}</strong><br />{description}
    </li>
  );
};

/**
 * Specialized component for rendering pricing information
 * Handles pricing structure and call-to-action
 */
const PricingDisplay = ({ pricing }) => {
  if (!pricing) return null;

  return (
    <>
      <IntroductionWrapper>
        <h3>{pricing.title}</h3>
        <span>{pricing.mainOffer.headline}</span>
        <ul>
          {pricing.features.map((feature, index) => (
            <Feature key={index} {...feature} />
          ))}
        </ul>
      </IntroductionWrapper>
      
      <IntroductionWrapper>
        <CallToActionWrapper text={pricing.cta.text} />
      </IntroductionWrapper>
    </>
  );
};

export default PricingDisplay;
